import { PaInterface } from '../interfaces/pa';

export class Pa implements PaInterface {
    id_pa?: number;
    compartment: string;
    name: string;
    cf: string;
    address: string;
    house_number: string;
    cap: number | null;
    municipality: string;
    province: string;

    constructor() {
        this.name = '';
        this.compartment = '';
        this.cf = '';
        this.address = '';
        this.house_number = '';
        this.cap = null;
        this.municipality = '';
        this.province = '';
    }
}